import { StoreProductField } from "app/models/types/store/product"

export const validateProductsQuantities = (types: StoreProductField['types']) =>
  Object.values(types).map((product) => {
    const p = {...product}
    if (p.selectedAmount >= p.maxAmount) {
      p.selectedAmount = p.maxAmount
    }
    return p
  }).reduce((acc, curr) => {
    acc[curr.id] = curr
    return acc
  }, {} as StoreProductField['types'])